// extracted by mini-css-extract-plugin
export var alignCenter = "_be-d";
export var bannerShown = "_be-6";
export var buttonContent = "_be-0";
export var cardList = "_be-1";
export var centerContent = "_be-2";
export var chevron = "_be-3";
export var closePanelButton = "_be-k";
export var conversationContextContainer = "_be-l";
export var conversationDetailContainer = "_be-4";
export var detailWrapper = "_be-7";
export var dropdownButton = "_be-e";
export var dropdownTitle = "_be-9";
export var fullHeight = "_be-5";
export var hidden = "_be-a";
export var icon = "_be-b";
export var mergeSuggestionWrapper = "_be-m";
export var panel = "_be-i";
export var portalButtonsWrapper = "_be-c";
export var right = "_be-j";
export var tableSummaryContainer = "_be-8";
export var tableSummaryHeader = "_be-g";
export var threeDotsButton = "_be-f";
export var wide = "_be-h";